import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import RetroButton from '../ui/RetroButton';

const PriceCard = ({ title, size, price, features, isPopular, badge }) => (
  <div className={`relative border-4 border-retro-brown rounded-[2.5rem] p-8 flex flex-col bg-white overflow-hidden ${isPopular ? 'shadow-[12px_12px_0px_0px_rgba(58,44,39,1)] lg:-translate-y-4' : 'shadow-retro'}`}>
    {badge && (
      <div className="absolute top-4 right-4 bg-retro-yellow border-2 border-retro-brown px-3 py-1 rounded-full font-display text-[10px] uppercase tracking-widest transform rotate-3">
        {badge}
      </div>
    )}
    
    <div className="mb-8">
      <h3 className="font-display text-3xl uppercase mb-1">{title}</h3>
      <p className="font-body font-black text-retro-teal text-xs uppercase tracking-widest mb-4">Ad Size: {size}</p>
      <div className="flex items-baseline gap-1">
        <span className="font-display text-6xl">${price}</span>
        <span className="font-body font-bold text-gray-400">/ edition</span>
      </div>
    </div>

    <ul className="space-y-4 mb-10 flex-1">
      {features.map((f, i) => (
        <li key={i} className="flex gap-3 font-body font-bold text-sm">
          <SafeIcon name="Check" className="text-retro-teal shrink-0 mt-0.5" />
          <span>{f}</span>
        </li>
      ))}
    </ul>

    <RetroButton variant={isPopular ? 'primary' : 'light'} className="w-full !py-3 !text-base">
      Choose {title} — ${price}
    </RetroButton>
  </div>
);

const Pricing = () => {
  return (
    <section className="py-24 border-b-4 border-retro-brown bg-retro-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter mb-4">Pick Your Placement</h2>
          <p className="font-body text-xl font-bold text-gray-500">Three slot sizes. All go into the same 10,000 West Valley homes.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <PriceCard 
            title="Half Slot" 
            size='~2" × 3"' 
            price="350" 
            features={[
              'Mailed to 10,000 West Valley homes',
              'Custom tracked QR code',
              'Digital version included',
              'Category exclusivity',
              'Done-for-you design & mailing'
            ]}
          />
          <PriceCard 
            title="Full Slot" 
            size='~4" × 3"' 
            price="600" 
            isPopular={true}
            badge="Most Popular"
            features={[
              '2× the visibility of Half Slot',
              'Premium positioning in the guide',
              'Highest perceived authority',
              'Everything in Half Slot included',
              'Done-for-you design & mailing'
            ]}
          />
          <PriceCard 
            title="XL Slot" 
            size='~4" × 6"' 
            price="900" 
            badge="Maximum Presence"
            features={[
              'The largest, most dominant placement',
              'Most dominant visual real estate',
              'Top-tier authority positioning',
              'Best perceived value per sq inch',
              'Full category ownership'
            ]}
          />
        </div>
      </div>
    </section>
  );
};

export default Pricing;